import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ApiTransactionService } from '@services/api-transaction.service';
import { SharedService } from '@services/shared.service';

import { Country, ErrorCode, GiftcardType } from '@models/Enums';
import { ScratchModel } from '@shared/models/ScratchModel';
import { SessionModel } from '@shared/models/SessionModel';
import { ApiCommunityService } from '@services/api-community.service';
import { ICountry } from '@shared/models/Interfaces';
import { SessionManager } from '@services/session-manager';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiLoyaltyPlanService } from '@services/api-loyalty-plans.service';
import { ApiAuthService } from '@services/api-auth.service';
import { CheckAutoAssignCodeModel } from '@shared/models/LoyaltyPlanModel';
@Component({
    selector: 'app-givi-scanner',
    templateUrl: './givi-scanner.component.html',
    styleUrls: ['./givi-scanner.component.scss']
})
export class GiviScannerComponent implements OnInit {

    @ViewChild('changeCountryModal', { static: true }) changeCountryModal: any;

    // QR Variants
    isReadQr = false;
    cameraAllowed = false; // Se utiliza para validar si la cámara tiene permisos
    qrScanned = false;
    url = '';
    code = '';
    showCamera = false;

    giviType: string; // Givi pop - Ticket - Product - Coupon
    popType = GiftcardType.POP; // Givi pop
    giviId: string;
    ticketId: number;
    uniqueLinkCode: string;
    linkId: number = null;

    communityFormId: number;

    selectedScratch: ScratchModel;

    communityId = 0;

    country: Country = Country.CR;
    session: SessionModel;

    //Country
    dropdownOpen = false;

    // Catálogo completo; solo se muestran los habilitados (EnabledCountries del API)
    private static readonly ALL_COUNTRIES: ICountry[] = [
        { id: Country.CR, name: 'Costa Rica', img: 'https://cdn-icons-png.flaticon.com/128/4854/4854928.png' },
        { id: Country.PA, name: 'Panamá', img: 'https://cdn-icons-png.flaticon.com/128/197/197590.png' },
        { id: Country.MX, name: 'México', img: 'https://cdn-icons-png.flaticon.com/128/197/197397.png' },
        { id: Country.CO, name: 'Colombia', img: 'https://cdn-icons-png.flaticon.com/128/197/197575.png' },
        { id: Country.NI, name: 'Nicaragua', img: 'https://cdn-icons-png.flaticon.com/128/197/197623.png' },
        { id: Country.GT, name: 'Guatemala', img: 'https://cdn-icons-png.flaticon.com/128/197/197597.png' }
    ];

    countries: ICountry[] = GiviScannerComponent.ALL_COUNTRIES.filter(c => c.id == Country.CR || c.id == Country.PA);

    selectedCountry: ICountry = this.countries[1]; 

    constructor(
        public modalService: NgbModal,
        public sharedService: SharedService,
        private router: Router,
        private apiCommunityService: ApiCommunityService,
        private apiLoyaltyPlanService: ApiLoyaltyPlanService,
        private apiTransactionService: ApiTransactionService,
        private apiAuthService: ApiAuthService) {
    }

    ngOnInit() {

        // Solo países habilitados en este ambiente
        this.apiAuthService.getEnabledCountries().then(enabled => {
            this.countries = GiviScannerComponent.ALL_COUNTRIES.filter(c => enabled.includes(c.id));
        });

        this.session = this.apiTransactionService.getSession();
        if (this.session && this.session.user) {

            this.cameraAllowed = true;

            // Por id (no por índice): soporta cualquier país habilitado
            this.selectedCountry = GiviScannerComponent.ALL_COUNTRIES.find(c => c.id == this.session.user.country)
                ?? this.countries[0];

        } else {

            // navigate to login
            this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(() => {
                this.router.navigate(['/market']);
            });
        }
    }

    goToGSA() {

        this.router.navigate(['/gsa-login']);
    }

    closeModal() {

        this.sharedService.setLoading(false);
        this.showCamera = false;

        this.router.navigate([`/market`]);
    }

    onCloseScratch() {

        this.selectedScratch = null;

        let url = this.router.url;

        this.router.navigateByUrl('/mimenu', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(url);
        });
    }

    scanSuccessHandler(url: string) {

        if (this.qrScanned) return;

        this.qrScanned = true;

        if (url) {

            this.url = url.toLowerCase();
            this.qrScanned = true;

            if (url.indexOf("holagivi") > 0 || url.indexOf("giviapp") > 0 ||
                url.indexOf("ewallet") > 0 || url.indexOf("localhost") > 0 || url.indexOf("migivi") > 0) {

                const urls = url.split('/').filter(x => x);
                const lastPart = urls.length ? `${urls.pop()}` : '';
                const countryPart = urls.length - 1 ? `${urls.pop()}` : '';

                this.country = Number(countryPart.split('?').shift());
                this.code = lastPart.split('?').shift();

                if (this.url.indexOf("form") > 0 && Number.isNaN(this.country)) this.country = Country.CR;

                if (this.country != this.session.user.country) {

                    const modalRef = this.modalService.open(this.changeCountryModal, {
                        backdrop: 'static', keyboard: false,
                        centered: true, windowClass: 'modal-full'
                    });

                    modalRef.result.finally(() => {

                        //refresh the route
                        let url = this.router.url;
                        this.router.navigateByUrl('/mimenu', { skipLocationChange: true }).then(() => {
                            this.router.navigateByUrl(url);
                        });

                    });

                } else {

                    this._decodeGivi(this.code);
                }
            } else {     

                if(url.includes("pl-aa")){

                    this.planAutoAssignCheck(url);
                    
                } else{

                    this.sharedService.showErrorAlert(null, 'Parece que este QR no es parte del ecosistema Givi o estás intentando escanear un givi con el escáner incorrecto.').then(_ => this.qrScanned = false);

                } 
            }

        } else {

            this.sharedService.showErrorAlert(null, 'El código QR es inválido.').then(_ => this.qrScanned = false);
        }
    }

    planAutoAssignCheck(url){

        const parts = url.split('/');

        if (parts.length >= 4) {

            //pl-aa/00001/000001/GUID
            const seccion = parts[0];
            const country = parts[1];
            const planId = parts[2];
            const assignmentCode = parts.slice(3).join('/'); 
            
            this.sharedService.setLoading(true); 
            //validate that the unique link is valid 

            let checkAutoAssignCodeModel = new CheckAutoAssignCodeModel({
                loyaltyPlanId: parseInt(planId, 10),
                customerId: this.session.user.id,
                assignmentCode: assignmentCode
            });

            this.apiLoyaltyPlanService.postCheckLinkAndLoyaltyPlansCustomer(checkAutoAssignCodeModel, country).then((res) => {

                this.sharedService.setLoading(false);

                if(res['Status'] == 201 || res['Status'] == 200){

                    // Si esta en otro tier del comercio, el sello cae en su tier vigente
                    const targetPlanId = res['Entity']?.targetLoyaltyPlanId || parseInt(planId, 10);

                    this.router.navigate(['/loyalty-plan-details', targetPlanId], 
                    { queryParams: { country: parseInt(country, 10), assignmentCode: assignmentCode } });

                    return;
                } 

                if(res['ErrorCode'] == ErrorCode.NotFound){

                    //if the plan is not found
                    this.sharedService.showErrorAlert(null, res['Message'] || 'No se encontro el plan de lealtad').then(_ => this.qrScanned = false);

                }else if(res['ErrorCode'] == ErrorCode.AlreadyUsed){

                    //if the assigment code is already used
                    this.sharedService.showErrorAlert(null, 'Este código QR ya fue utilizado').then(_ => this.qrScanned = false);

                }else if(res['ErrorCode'] == ErrorCode.NotInPlan){

                    //if the user is not part of the plan, redirect to join
                    this.sharedService.showErrorAlert(null, 'No formas parte de este plan de lealtad').then(_ => {
                        this.router.navigate(['/loyalty-plan-join', parseInt(planId, 10)], { queryParams: { country: parseInt(country, 10) } });
                    });

                }else{

                    this.sharedService.showErrorAlert(null, res['Message'] || 'No se pudo usar este código QR').then(_ => this.qrScanned = false);
                }

            },
            (err) => {

                    this.sharedService.showErrorAlert(null, 'Ocurrio un error intentado leer los datos.').then(_ => this.qrScanned = false);
                    this.sharedService.setLoading(false);
            });

        } else{

            this.sharedService.showErrorAlert(null, 'Parece que este QR no es parte del ecosistema Givi o estás intentando escanear un givi con el escáner incorrecto.').then(_ => this.qrScanned = false);
        }          
    }

    toggleDropdown() {

        this.dropdownOpen = !this.dropdownOpen;
    }

    selectCountry(country: ICountry) {

        this.selectedCountry = country;
        this.dropdownOpen = false;

        //set the session country
        const session = this.apiTransactionService.getSession();
        session.user.country = country.id;
        SessionManager.setSession(session);

        this.modalService.dismissAll();
    }

    private _decodeGivi(urlCode: string) {

        // Valida si hay que establecer ambiente TEST
        if (urlCode.toUpperCase().indexOf('$TST') > 0) {
            SessionManager.setDemoMode(true);
            urlCode = urlCode.replace('$TST', '')
        }

        const decodedId = window.atob(urlCode);

        if (decodedId) {

            this.giviType = decodedId.split('-')[0];

            if (this.url.indexOf("pack") > 0) this.giviType = 'pk';
            else if (this.url.indexOf("scratch") > 0) this.giviType = 'sc';
            else if (this.url.indexOf("form") > 0) this.giviType = 'fm';
            else if (this.url.indexOf("plan") > 0) this.giviType = 'lp';

            if (this.giviType == 'pk' || this.giviType == 'sc') {

                this.giviId = decodedId.split('-')[0];
                this.uniqueLinkCode = decodedId.split('-')[1];


                if (this.uniqueLinkCode != null && this.giviType == 'pk') this._checkUniqueLinkPack();
                else if (this.uniqueLinkCode != null && this.giviType == 'sc') this._checkUniqueLinkScratch();
                else this._sendTo();

            } else if (this.giviType == 'fm') {

                this.giviId = decodedId.split('-')[1];
                this.uniqueLinkCode = decodedId.split('-')[2];
                this.communityFormId = parseInt(decodedId.split('-')[3], 10);


                if (this.uniqueLinkCode != null && this.giviType == 'fm') this._checkUniqueLinkForm();
                else this._sendTo();

            } else if (this.giviType == 'lp') {

                this.giviId = decodedId.split('-')[0];
                this.linkId = parseInt(decodedId.split('-')[1]);
                this._sendTo();

            } else {

                //checkout cases 
                this.giviId = decodedId.split('-')[1];

                this.ticketId = 0;
                this.popType = GiftcardType.POP;
                this.uniqueLinkCode = '';

                if (decodedId.split('-')[2] != undefined) {
                    if (decodedId.split('-')[2] == 'gv') this.popType = GiftcardType.Donation;
                    if (decodedId.split('-')[2] == 'me') this.popType = GiftcardType.Merch;
                }

                //get the communityId for the request
                if (this.giviType == 'gf' && decodedId.split('-')[3] != undefined) {
                    this.communityId = parseInt(decodedId.split('-')[3], 10);
                }

                //saca el id del ticket de link privado y el código único
                if (decodedId.split('-').length >= 3) {

                    this.uniqueLinkCode = decodedId.split('-')[2];

                    //just used for tickets
                    if (decodedId.split('-').length > 3) {
                        this.ticketId = parseInt(decodedId.split('-')[3], 10);
                    }

                    //can have third param so we need to check if it is a unique link code
                    if (!(this.uniqueLinkCode?.length > 4)) {

                        this.uniqueLinkCode = null;
                        this._sendTo();
                    }
                    // Search if the unique code 
                    else if (this.uniqueLinkCode?.length > 4) {

                        this.apiTransactionService.checkUniqueLinkCode(this.uniqueLinkCode, this.country).then(
                            (canAccess) => {

                                if (canAccess == 'true') this._sendTo();
                                else this.sharedService.showErrorAlert(null, 'El QR es de uso único y este ya fue utilizado').then(_ => this.qrScanned = false);

                            }).catch(err => {

                                this.sharedService.showErrorAlert(null, 'No se logró validar el enlace único').then(_ => this.qrScanned = false);
                            }
                            );
                    }
                } else this._sendTo();

            }
        } else {

            this.sharedService.showErrorAlert(null, 'El código QR es inválido.').then(_ => this.qrScanned = false);
        }
    }

    private _sendTo() {

        this.sharedService.setPageBack(false);
        this.sharedService.setPageTitle('');

        //get the info depending on the checkout Type
        //else if (this.giviType == 'pr') this.router.navigate(['/product-info', this.giviId]);
        if (this.giviType == 'gf') this.router.navigate(['/pop-info', this.giviId, this.popType], { queryParams: { communityId: this.communityId } });
        else if (this.giviType == 'ev' && this.ticketId <= 0) this.router.navigate(['/event-info', this.giviId]);
        else if (this.giviType == 'ev' && this.ticketId > 0) this.router.navigate(['/event-info', this.giviId], { queryParams: { ticketId: this.ticketId, uniqueLinkCode: this.uniqueLinkCode } });
        else if (this.giviType == 'pk') this.router.navigate(['/package-detail', this.giviId], { queryParams: { uniqueLinkCode: this.uniqueLinkCode } });
        else if (this.giviType == 'cp') this.router.navigate(['/coupon-info', this.giviId], { queryParams: { uniqueLinkCode: this.uniqueLinkCode, country: this.country } });
        else if (this.giviType == 'sc') this._playScratch();
        else if (this.giviType == 'lp') this.router.navigate(['/loyalty-plan-join', this.giviId], { queryParams: { country: this.country, linkId: this.linkId } });

        else if (this.giviType == 'fm')
            this.router.navigate(['/community-join', this.giviId],
                { queryParams: { step: 2, formId: this.communityFormId, requestCode: this.uniqueLinkCode, country: this.country } });


    }

    private _playScratch() {

        this.sharedService.setLoading(true);

        this.apiTransactionService.getFullScratch(Number(this.giviId)).then((scratch) => {

            this.selectedScratch = scratch;
            this.sharedService.setLoading(false);

        });
    }

    private _checkUniqueLinkScratch() {

        //valida que el link unico no se haya usado
        this.apiTransactionService.checkUniqueScratchLinkCode(this.uniqueLinkCode).then(
            (canAccess) => {

                if (canAccess == 'true') this._sendTo();
                else this.sharedService.showErrorAlert(null, 'El QR es de uso único y este ya fue utilizado').then(_ => this.qrScanned = false);

            }).catch(err => {

                this.sharedService.showErrorAlert(null, 'No se logró validar el enlace único').then(_ => this.qrScanned = false);
            });
    }

    private _checkUniqueLinkPack() {

        if (this.uniqueLinkCode?.length > 4) {

            this.apiTransactionService.checkUniquePackLinkCode(this.uniqueLinkCode, this.country).then(
                (canAccess) => {

                    if (canAccess == 'true') this._sendTo();
                    else this.sharedService.showErrorAlert(null, 'El QR es de uso único y este ya fue utilizado').then(_ => this.qrScanned = false);

                }).catch(err => {

                    this.sharedService.showErrorAlert(null, 'No se logró validar el enlace único').then(_ => this.qrScanned = false);
                }
                );

        } else this._sendTo();
    }

    private _checkUniqueLinkForm() {

        if (this.uniqueLinkCode?.length > 4) {

            this.apiCommunityService.checkUniqueLinkCode(this.uniqueLinkCode, this.country).then(
                (canAccess) => {

                    if (canAccess == 'true') this._sendTo();
                    else this.sharedService.showErrorAlert(null, 'El QR es de uso único y este ya fue utilizado').then(_ => this.qrScanned = false);

                }).catch(err => {

                    this.sharedService.showErrorAlert(null, 'No se logró validar el enlace único').then(_ => this.qrScanned = false);
                }
                );

        } else this._sendTo();
    }
}
